import script from "./inventoryTransferSendDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./inventoryTransferSendDetail.vue?vue&type=script&setup=true&lang=js"

import "./inventoryTransferSendDetail.vue?vue&type=style&index=0&id=5c54787e&lang=less"

const __exports__ = script;

export default __exports__